var _path;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgNavIcon2(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 30,
    height: 30,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 0 C3.12578143 1.6720747 5.39281175 3.7856235 7 7 C7.51368822 11.08015218 7.89771513 15.20097889 6.0234375 18.95703125 C4.1728879 21.29008612 2.48237692 22.817479 -0.3125 23.875 C-0.869375 23.91625 -1.42625 23.9575 -2 24 C-2.33 21.36 -2.66 18.72 -3 16 C-1.68 15.34 -0.36 14.68 1 14 C1 11.36 1 8.72 1 6 C0.01 6.495 0.01 6.495 -1 7 C-7.53333333 7.23333333 -7.53333333 7.23333333 -10 6 C-10 8.64 -10 11.28 -10 14 C-8.68 14.66 -7.36 15.32 -6 16 C-7 19 -7 19 -9 20 C-8.34 21.32 -7.68 22.64 -7 24 C-10.64626587 23.79164195 -12.00957126 22.99170491 -14.8125 20.5625 C-17.48936887 17.03583149 -17.70932131 13.74703216 -17.5 9.41015625 C-16.68318836 5.4728689 -14.92240049 3.71365759 -12 1 C-8.27533151 -0.86233425 -4.05504687 -0.57130829 0 0 Z ",
    fill: "#FFFFFF",
    transform: "translate(20,3)"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgNavIcon2);
export default __webpack_public_path__ + "static/media/nav-icon2.116d3b8533ca45b92aad89961a25981c.svg";
export { ForwardRef as ReactComponent };